import { mapState } from "vuex";
export const tableIndexMixins = {
  computed: {
    tableTopBarList() {
      let topbarList = [
          {
              name: "桌位管理",
              isActive: false,
              path: "/table",
              icon:require("@/assets/img/menuIcons/icon-table.png")
          },
          {
              name: "桌位类型",
              isActive: false,
              path: "/table/classify",
              icon:require("@/assets/img/menuIcons/icon-tableclassify.png")
          },
          {
              name: "桌位区域",
              isActive: false,
              path: "/table/region",
              icon:require("@/assets/img/menuIcons/icon-tableregion.png")
          }
      ];
      topbarList.forEach(val => {
          if (val.path == this.$route.path) {
              val.isActive = true;
          }
      });
      return topbarList;
  }
  },
}
